/* ============================================================
   snf-compatibility-matcher.js
   Logic for sections/compatibility-matcher.liquid ONLY.

   Three files, one job each:
     assets/snf-compatibility-matcher.css   colours + layout
     assets/snf-compatibility-matcher.js    this file
     sections/compatibility-matcher.liquid  markup + schema

   DEPENDS ON these ids - do not rename:
     mtcForm mtcErr mtcGoBtn mtcResult mtcRetryBtn
     m1Name m1Day m1Month m1Year  m2Name m2Day m2Month m2Year
     mtcScore mtcVerdict mtcBody
     mtcIcon1 mtcSign1 mtcArch1  mtcIcon2 mtcSign2 mtcArch2
   ============================================================ */
(function(){
'use strict';
var goBtn=document.getElementById('mtcGoBtn');
if(!goBtn)return;

var ICONS={
  rake:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M20 4L9 17l3 13 8 6 8-6 3-13L20 4z"/><path d="M14 20h12M20 14v12" stroke-linecap="round" stroke-opacity=".4"/></svg>',
  idealLover:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="20" cy="20" r="15"/><path d="M20 9v11l6 3" stroke-linecap="round" stroke-opacity=".5"/></svg>',
  star:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="20" cy="20" r="5"/><path d="M20 4v4M20 32v4M4 20h4M32 20h4M8.6 8.6l2.8 2.8M28.6 28.6l2.8 2.8M31.4 8.6l-2.8 2.8M11.4 28.6l-2.8 2.8" stroke-linecap="round"/></svg>',
  natural:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M20 36V20M20 20C20 12 15 8 8 6c2 6 5 11 12 14M20 20c0-8 5-12 12-14-2 6-5 11-12 14" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  charmer:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="20" cy="13" r="6"/><path d="M8 34c0-6.6 5.4-12 12-12s12 5.4 12 12" stroke-linecap="round"/></svg>',
  charismatic:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="20" cy="20" r="6"/><path d="M20 4v6M20 30v6M4 20h6M30 20h6M9 9l4 4M27 27l4 4M31 9l-4 4M13 27l-4 4" stroke-linecap="round" stroke-opacity=".7"/></svg>',
  siren:'<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.1"><path d="M20 4C14 7 11 12 11 18c0 4 2 7 5 9l4 3 4-3c3-2 5-5 5-9 0-6-3-11-9-14z"/><path d="M20 4v26M16 12c2 1 3 2 4 2s2-1 4-2" stroke-linecap="round" stroke-opacity=".4"/></svg>'
};

var P={
  rake:{name:"The Rake",beats:["natural","charismatic"]},
  idealLover:{name:"The Ideal Lover",beats:["siren","natural"]},
  star:{name:"The Star",beats:["charmer","natural"]},
  natural:{name:"The Natural",beats:["rake","siren"]},
  charmer:{name:"The Charmer",beats:["idealLover","siren"]},
  charismatic:{name:"The Charismatic",beats:["star","charmer"]},
  siren:{name:"The Siren",beats:["rake","idealLover"]}
};

var SIGNS=[
  {name:"Capricorn",sym:"\u2651",from:[12,22],to:[1,19],element:"Earth",compat:["taurus","virgo","scorpio","pisces"]},
  {name:"Aquarius",sym:"\u2652",from:[1,20],to:[2,18],element:"Air",compat:["gemini","libra","aries","sagittarius"]},
  {name:"Pisces",sym:"\u2653",from:[2,19],to:[3,20],element:"Water",compat:["cancer","scorpio","capricorn","taurus"]},
  {name:"Aries",sym:"\u2648",from:[3,21],to:[4,19],element:"Fire",compat:["leo","sagittarius","gemini","aquarius"]},
  {name:"Taurus",sym:"\u2649",from:[4,20],to:[5,20],element:"Earth",compat:["virgo","capricorn","cancer","pisces"]},
  {name:"Gemini",sym:"\u264A",from:[5,21],to:[6,20],element:"Air",compat:["libra","aquarius","aries","leo"]},
  {name:"Cancer",sym:"\u264B",from:[6,21],to:[7,22],element:"Water",compat:["scorpio","pisces","taurus","virgo"]},
  {name:"Leo",sym:"\u264C",from:[7,23],to:[8,22],element:"Fire",compat:["aries","sagittarius","gemini","libra"]},
  {name:"Virgo",sym:"\u264D",from:[8,23],to:[9,22],element:"Earth",compat:["taurus","capricorn","cancer","scorpio"]},
  {name:"Libra",sym:"\u264E",from:[9,23],to:[10,22],element:"Air",compat:["gemini","aquarius","leo","sagittarius"]},
  {name:"Scorpio",sym:"\u264F",from:[10,23],to:[11,21],element:"Water",compat:["cancer","pisces","virgo","capricorn"]},
  {name:"Sagittarius",sym:"\u2650",from:[11,22],to:[12,21],element:"Fire",compat:["aries","leo","libra","aquarius"]}
];

function zodiacFromDOB(month,day){
  for(var i=0;i<SIGNS.length;i++){
    var s=SIGNS[i],f=s.from,t=s.to;
    if(f[0]===t[0]){if(month===f[0]&&day>=f[1]&&day<=t[1])return s;}
    else{if(month===f[0]&&day>=f[1])return s;if(month===t[0]&&day<=t[1])return s;}
  }
  return SIGNS[0];
}
function digitSum(s){return (String(s).match(/\d/g)||[]).reduce(function(a,d){return a+parseInt(d,10);},0);}
function reduceNum(n){
  n=Math.abs(Math.round(n));
  while(n>9){
    if(n===11||n===22||n===33)return n;
    n=String(n).split('').reduce(function(a,d){return a+parseInt(d,10);},0);
  }
  return n;
}
function lifePath(d,m,y){return reduceNum(digitSum(String(d)+String(m)+String(y)));}

var ARCH_KEYS=Object.keys(P);
function archetypeFromSeed(name,d,m){
  var seed=digitSum(name.toUpperCase().replace(/[^A-Z]/g,''))+parseInt(d,10)+parseInt(m,10);
  return ARCH_KEYS[seed%ARCH_KEYS.length];
}
function calcProfile(name,d,m,y){
  return {
    name:name,
    lp:lifePath(d,m,y),
    sign:zodiacFromDOB(parseInt(m,10),parseInt(d,10)),
    archKey:archetypeFromSeed(name,d,m)
  };
}

var EL={
  Fire:{Fire:60,Earth:40,Air:80,Water:50},
  Earth:{Fire:40,Earth:70,Air:50,Water:80},
  Air:{Fire:80,Air:65,Earth:50,Water:40},
  Water:{Fire:50,Earth:80,Air:40,Water:75}
};

goBtn.onclick=function(){
  var v=function(id){return document.getElementById(id).value;};
  var m1n=v('m1Name').trim(),m1d=v('m1Day'),m1m=v('m1Month'),m1y=v('m1Year');
  var m2n=v('m2Name').trim(),m2d=v('m2Day'),m2m=v('m2Month'),m2y=v('m2Year');
  var err=document.getElementById('mtcErr');

  if(!m1n||!m1d||!m1m||!m1y||!m2n||!m2d||!m2m||!m2y){err.classList.add('show');return;}
  err.classList.remove('show');

  var p1=calcProfile(m1n,m1d,m1m,m1y);
  var p2=calcProfile(m2n,m2d,m2m,m2y);
  var a1=P[p1.archKey],a2=P[p2.archKey];

  var score=(EL[p1.sign.element]&&EL[p1.sign.element][p2.sign.element])||55;
  var lpDiff=Math.abs(p1.lp-p2.lp);
  if(lpDiff===0)score+=15;else if(lpDiff<=2)score+=8;else if(lpDiff>=6)score-=8;
  if(a1.beats.indexOf(p2.archKey)>=0)score+=10;
  if(a2.beats.indexOf(p1.archKey)>=0)score-=5;
  if(p1.sign.compat.indexOf(p2.sign.name.toLowerCase())>=0)score+=12;
  score=Math.min(99,Math.max(22,Math.round(score)));

  var tier=score>=80?'great':score>=65?'good':score>=48?'tense':'clash';
  var verdicts={great:'Deeply Compatible',good:'Strong Connection',tense:'Charged Tension',clash:'Dangerous Chemistry'};
  var bodies={
    great:p1.name+' and '+p2.name+' carry a rare harmony. Your elements align, your numbers resonate, and your archetypes amplify rather than conflict. This is not easy \u2014 but it is real.',
    good:'There is genuine chemistry here. '+a1.name+' and '+a2.name+' complement each other in ways that create lasting attraction. The friction makes it more interesting, not less.',
    tense:p1.name+' and '+p2.name+' operate on fundamentally different frequencies. The tension is real \u2014 and tension becomes electricity, or it becomes exhaustion. The difference is awareness.',
    clash:a1.name+' meets '+a2.name+' and something sparks \u2014 not always safely. This combination is either transformative or consuming. There is no middle ground.'
  };

  document.getElementById('mtcScore').textContent=score+'%';
  document.getElementById('mtcVerdict').textContent=verdicts[tier];
  document.getElementById('mtcBody').textContent=bodies[tier];
  document.getElementById('mtcIcon1').innerHTML=ICONS[p1.archKey];
  document.getElementById('mtcIcon2').innerHTML=ICONS[p2.archKey];
  document.getElementById('mtcSign1').textContent=p1.sign.sym+' '+p1.sign.name;
  document.getElementById('mtcSign2').textContent=p2.sign.sym+' '+p2.sign.name;
  document.getElementById('mtcArch1').innerHTML=p1.name+'<em>'+a1.name+'</em>';
  document.getElementById('mtcArch2').innerHTML=p2.name+'<em>'+a2.name+'</em>';

  document.getElementById('mtcForm').style.display='none';
  document.getElementById('mtcResult').classList.add('show');
};

document.getElementById('mtcRetryBtn').onclick=function(){
  document.getElementById('mtcResult').classList.remove('show');
  document.getElementById('mtcForm').style.display='block';
  ['m1Name','m1Day','m1Month','m1Year','m2Name','m2Day','m2Month','m2Year'].forEach(function(id){
    document.getElementById(id).value='';
  });
};

})();
